import {
  Link,
  useLocation
} from "react-router-dom";

import {
  motion
} from "framer-motion";

import {
  FaHome,
  FaHeart,
  FaShoppingBag,
  FaUser
} from "react-icons/fa";

function MobileBottomNav() {

  const location = useLocation();

  const tabs = [
    {
      icon: <FaHome />,
      path: "/",
      label: "Home"
    },
    {
      icon: <FaHeart />,
      path: "/wishlist",
      label: "Wishlist"
    },
    {
      icon: <FaShoppingBag />,
      path: "/cart",
      label: "Cart"
    },
    {
      icon: <FaUser />,
      path: "/account",
      label: "Account"
    }
  ];

  return (

    <div className="
      md:hidden
      fixed bottom-4 left-1/2
      -translate-x-1/2
      z-[100]
      w-[92%]
      max-w-md
    ">

      <div className="
        backdrop-blur-2xl
        bg-white/80
        border border-white/30
        shadow-2xl
        rounded-full
        px-6 py-3
      ">

        <div className="
          flex items-center
          justify-between
        ">

          {tabs.map((tab) => {

            const active =
              location.pathname === tab.path;

            return (

              <Link
                key={tab.path}
                to={tab.path}
                className="
                  relative flex flex-col
                  items-center justify-center
                  text-xs
                "
              >

                {/* ACTIVE BG */}

                {active && (

                  <motion.div
                    layoutId="bottomNav"
                    className="
                      absolute inset-0
                      bg-black rounded-full
                    "
                    transition={{
                      type: "spring",
                      stiffness: 300,
                      damping: 25
                    }}
                  />

                )}

                {/* CONTENT */}

                <div className="
                  relative z-10
                  flex flex-col items-center
                  px-4 py-2
                ">

                  <span className={`
                    text-lg mb-1
                    ${
                      active
                        ? "text-white"
                        : "text-stone-500"
                    }
                  `}>

                    {tab.icon}

                  </span>

                  <span className={`
                    text-[10px]
                    ${
                      active
                        ? "text-white"
                        : "text-stone-500"
                    }
                  `}>

                    {tab.label}

                  </span>

                </div>

              </Link>

            );

          })}

        </div>

      </div>

    </div>

  );

}

export default MobileBottomNav;